<template>
  <div class="pb-16 md:pb-0">
    <div class="px-3 pb-6 md:px-6" v-if="strategies_msg != 'Nenhum investimento encontrado'">
      <performance-header
        v-if="Object.keys(strategies).length > 0"
        @listInvestment="listInvestment"
        @chooseItem="chooseItem"
        @activeLogs="selectedComponent = 'LogsTables'"
        :data="strategies"
        :chart="selectedComponent == 'ChartCandles' ? true : false"
      ></performance-header>
      <div is="transition" v-on:enter="enter" v-on:leave="leave" v-bind:css="false" appear mode="out-in">
        <component
          v-if="Object.keys(investment).length > 0"
          :is="selectedComponent"
          :data="investment"
          :period="selected_period"
        />
      </div>
    </div>
    <div v-else>
      <div class="grid grid-cols-2 items-center px-32 py-32 text-center">
        <div>
          <h1 class="pt-6 text-3xl font-bold text-ontick-steel-900 dark:text-gray-300">Vamos começar a investir?</h1>
          <p class="py-3 text-sm text-ontick-steel-500 dark:text-gray-400">
            Não encontramos nenhum investimento na sua conta. Acesse o marketplace para adicionar estratégias à sua
            conta.
          </p>
          <ontick-button @click.native="$router.push({ name: 'Marketplace' })" class="mt-4 w-full uppercase"
            >Acessar estratégias</ontick-button
          >
        </div>
        <div>
          <span v-html="not_historic"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { not_historic } from "../../../../assets/icons/isometric";
import StrategyResume from "../../components/performance/strategy/strategy-resume.component.vue";
import OrderTables from "../../components/performance/order/table.component";
import LogsTables from "../../components/performance/logs/table.component";
import ChartCandles from "../../components/performance/chart/chart.component.vue";
export default {
  name: "performance",
  components: {
    PerformanceHeader: () => import("../../components/performance/header/performance-header.component"),
    StrategyResume,
    OrderTables,
    LogsTables,
    ChartCandles,
  },

  data() {
    return {
      tab: {
        main: true,
        orders: false,
        logs: false,
        charts: false,
      },
      selectedComponent: "StrategyResume",
      requestDate: {},
      not_historic: not_historic,
      selected_period: {},
    };
  },
  computed: {
    ...mapGetters({
      strategies: "performance/getStrategies",
      investment: "performance/getInvestment",
      strategies_msg: "performance/getStrategiesMsg",
      selectedAccount: "accountTypes/getSelectedAccount",
    }),
  },
  async mounted() {
    if (Object.keys(this.selectedAccount).length > 0) {
      await this.fetchAccounts(this.selectedAccount);
    }
  },
  watch: {
    selectedAccount: {
      deep: true,
      handler(value) {
        this.fetchAccounts(value);
        return value;
      },
    },
  },
  methods: {
    ...mapActions({
      fetchAccounts: "performance/fetchAccounts",
      detailsStrategy: "performance/detailsStrategy",
    }),

    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.95,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    chooseItem(value) {
      if (value.label == "Resumo") return (this.selectedComponent = "StrategyResume");
      if (value.label == "Ordens") return (this.selectedComponent = "OrderTables");
      if (value.label == "Logs") return (this.selectedComponent = "LogsTables");
      if (value.label == "Gráficos") return (this.selectedComponent = "ChartCandles");
    },

    listInvestment(investment) {
      let params = {
        start: investment.date_range.start,
        end: investment.date_range.end,
        investment_id: investment.investment.investment_id,
      };
      this.selected_period = params;
      if (investment.range) {
        this.detailsStrategy(investment);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./performance.component.scss";
</style>
